export const accountConstants = {
  DASHBOARD_ACCOUNT_LIST_REQUEST: "DASHBOARD_ACCOUNT_LIST_REQUEST",
  DASHBOARD_ACCOUNT_LIST_COMPLETE: "DASHBOARD_ACCOUNT_LIST_COMPLETE",

  SAVING_ACCOUNT_LIST_REQUEST: "SAVING_ACCOUNT_LIST_REQUEST",
  SAVING_ACCOUNT_LIST_COMPLETE: "SAVING_ACCOUNT_LIST_COMPLETE",
  SAVING_ACCOUNT_LIST_ERROR: "SAVING_ACCOUNT_LIST_ERROR",
  SAVING_ACCOUNT_STATUS: "SAVING_ACCOUNT_STATUS",
  SAVING_ACCOUNT_RESET: "SAVING_ACCOUNT_RESET",

  DEFAULT_TYPE: "DEFAULT",

  ACCOUNT_LIST_REQUEST: "ACCOUNT_LIST_REQUEST",
  ACCOUNT_LIST_COMPLETE: "ACCOUNT_LIST_COMPLETE",
  ACCOUNT_LIST_ERROR: "ACCOUNT_LIST_ERROR",
  ACCOUNT_STATUS: "ACCOUNT_STATUS",
  ACCOUNT_RESET: "ACCOUNT_RESET",

  SAVING_ACCOUNT_CODE: "SBA",
  CURRENT_ACCOUNT_CODE: "CAA",
  DEPOSIT_ACCOUNT_CODE: "TDA",
  LOAN_ACCOUNT_CODE: "LAA",
  ALL_ACCOUTS: "ALL",

  ACCOUNT_NUMBER: "ACCOUNT_NUMBER",
  ACCOUNT_TRANSACTION_HISTORY_LIST_REQUEST:
    "ACCOUNT_TRANSACTION_HISTORY_LIST_REQUEST",
  ACCOUNT_TRANSACTION_HISTORY_LIST_COMPLETE:
    "ACCOUNT_TRANSACTION_HISTORY_LIST_COMPLETE",
  ACCOUNT_TRANSACTION_HISTORY_LIST_ERROR:
    "ACCOUNT_TRANSACTION_HISTORY_LIST_ERROR",
  CLEAR_ACCOUNT_TRANSACTION_HISTORY_LIST:
    "CLEAR_ACCOUNT_TRANSACTION_HISTORY_LIST",

  CLEAR_ACCOUNT_TRANSACTION_STATEMENT_HISTORY_LIST:
    "CLEAR_ACCOUNT_TRANSACTION_STATEMENT_HISTORY_LIST",
  ACCOUNT_TRANSACTION_STATEMENT_HISTORY_LIST_REQUEST:
    "ACCOUNT_TRANSACTION_STATEMENT_HISTORY_LIST_REQUEST",
  ACCOUNT_TRANSACTION_STATEMENT_HISTORY_LIST_COMPLETE:
    "ACCOUNT_TRANSACTION_STATEMENT_HISTORY_LIST_COMPLETE",
  ACCOUNT_TRANSACTION_STATEMENT_HISTORY_LIST_ERROR:
    "ACCOUNT_TRANSACTION_STATEMENT_HISTORY_LIST_ERROR",

  EPASSBOOK_LIST_REQUEST: "EPASSBOOK_LIST_REQUEST",
  EPASSBOOK_LIST_COMPLETE: "EPASSBOOK_LIST_COMPLETE",
  EPASSBOOK_LIST_ERROR: "EPASSBOOK_LIST_ERROR",
  CLEAR_EPASSBOOK_LIST: "CLEAR_EPASSBOOK_LIST",
  STATUS_NO_SHORT: "N",
  STATUS_YES_SHORT: "Y",

  ACCOUNT_VIEW_TYPE: "ACCOUNT_VIEW_TYPE",
  ACCOUNT_VIEW_TYPE_RESET: "ACCOUNT_VIEW_TYPE_RESET",

  SAVING_ACCOUNT_TYPE: "Savings",
  DEPOSIT_ACCOUNT_TYPE: "Deposit",
  ISLAMIC_ACCOUNT_TYPE: "Islamic Investments",
  CURRENT_ACCOUNT_TYPE: "Current",

  VIEWACCOUNHOLDERS: "vieweAccounHolders",
  CAA: "CAA",
  SBA: "SBA",
  TDA: "TDA",
  TUA: "TUA",

  ACCOUNT_HISTORY_LIST_REQUEST: "ACCOUNT_HISTORY_LIST_REQUEST",
  ACCOUNT_HISTORY_LIST_COMPLETE: "ACCOUNT_HISTORY_LIST_COMPLETE",
  ACCOUNT_HISTORY_LIST_ERROR: "ACCOUNT_HISTORY_LIST_ERROR",

  ACCOUNT_DETAILS_REQUEST: "ACCOUNT_DETAILS_REQUEST",
  ACCOUNT_DETAILS_COMPLETE: "ACCOUNT_DETAILS_COMPLETE",
  ACCOUNT_DETAILS_ERROR: "ACCOUNT_DETAILS_ERROR",

  CREDIT_CARD_NUMBER: "Credit Card Number",
  CARD_ACCOUNT_NUMBER: "Card Account Number",

  DEBIT_CREDIT_INDICATOR_TYPE_D: "DEBIT",
  DEBIT_CREDIT_INDICATOR_TYPE_DR: "CREDIT",

  ACCOUNT_DEFAULT_YES: "Y",

  GET_ELIGIBLE_CASA_LIST_REQUEST: "GET_ELIGIBLE_CASA_LIST_REQUEST",
  GET_ELIGIBLE_CASA_LIST_COMPLETE: "GET_ELIGIBLE_CASA_LIST_COMPLETE",
  GET_ELIGIBLE_CASA_LIST_ERROR: "GET_ELIGIBLE_CASA_LIST_ERROR",
  SAVING_ACCOUNTS_OPEN_INITIATE_REQUEST:
    "SAVING_ACCOUNTS_OPEN_INITIATE_REQUEST",
  SAVING_ACCOUNTS_OPEN_INITIATE_ERROR: "SAVING_ACCOUNTS_OPEN_INITIATE_ERROR",
  SAVING_ACCOUNTS_OPEN_INITIATE_COMPLETE:
    "SAVING_ACCOUNTS_OPEN_INITIATE_COMPLETE",
  SAVING_ACCOUNTS_OTP_RESEND_REQUEST: "SAVING_ACCOUNTS_OTP_RESEND_REQUEST",
  SAVING_ACCOUNTS_OTP_RESEND_COMPLETE: "SAVING_ACCOUNTS_OTP_RESEND_COMPLETE",
  SAVING_ACCOUNTS_OTP_RESEND_ERROR: "SAVING_ACCOUNTS_OTP_RESEND_ERROR",
  SAVING_ACCOUNTS_OTP_CONFIRMATION_REQUEST:
    "SAVING_ACCOUNTS_OTP_CONFIRMATION_REQUEST",
  SAVING_ACCOUNTS_OTP_CONFIRMATION_COMPLETE:
    "SAVING_ACCOUNTS_OTP_CONFIRMATION_COMPLETE",
  SAVING_ACCOUNTS_OTP_CONFIRMATION_ERROR:
    "SAVING_ACCOUNTS_OTP_CONFIRMATION_ERROR",
  SAVING_ACCOUNTS_RECEIPT_REQUEST: "SAVING_ACCOUNTS_RECEIPT_REQUEST",
  SAVING_ACCOUNTS_RECEIPT_COMPLETE: "SAVING_ACCOUNTS_RECEIPT_COMPLETE",
  SAVING_ACCOUNTS_RECEIPT_ERROR: "SAVING_ACCOUNTS_RECEIPT_ERROR",
  SET_SELECTED_SAVINGS_DEBIT_ACCOUNT: "SET_SELECTED_SAVINGS_DEBIT_ACCOUNT",
  CLEAR_SAVING_ACCOUNTS: "CLEAR_SAVING_ACCOUNTS",
  SET_SAVING_ACCOUNT_PRODUCT_TYPE: "SET_SAVING_ACCOUNT_PRODUCT_TYPE",
  SET_SAVING_ACCOUNT_AMOUNT: "SET_SAVING_ACCOUNT_AMOUNT",
  SET_SAVING_ACCOUNT_PRODUCT_CODE: "SET_SAVING_ACCOUNT_PRODUCT_CODE",
  SET_SAVING_ACCOUNT_FORM_CHANGED: "SET_SAVING_ACCOUNT_FORM_CHANGED",

  ONLINE_BANKING_CHANNEL: "ONLINE",
  OVER_THE_COUNTER_CHANNEL: "OTC",
  SET_ACTIVE_TAB: "SET_ACTIVE_TAB",
  CLEAR_ACCOUNT_DETAILS: "CLEAR_ACCOUNT_DETAILS",

  DASHBOARD_BANNER_LIST_ERROR: "DASHBOARD_BANNER_LIST_ERROR",

  DOWNLOAD_ACCOUNT_STATEMENT_REQUEST: "DOWNLOAD_ACCOUNT_STATEMENT_REQUEST",
  DOWNLOAD_ACCOUNT_STATEMENT_COMPLETE: "DOWNLOAD_ACCOUNT_STATEMENT_COMPLETE",
  DOWNLOAD_ACCOUNT_STATEMENT_ERROR: "DOWNLOAD_ACCOUNT_STATEMENT_ERROR",
};
